import { render, staticRenderFns } from "./stulist.vue?vue&type=template&id=606a8b14"
import script from "./stulist.vue?vue&type=script&lang=js"
export * from "./stulist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports